import { triggerSimpleAjax } from '../../../helpers/httpHelper'
import { GET_CHECK_PENDING_REQUEST_RETAILER_EDIT } from '../../../../src/helpers/constants/apiUrl'

export function getCheckPendingRequestRetailerEdit(workflow_object_id='') {
    return new Promise((res, rej) => {
        if (!workflow_object_id) {
            return res({ pending_request_exist: false, count_pending_request: 0 });
        }
        const url = `${GET_CHECK_PENDING_REQUEST_RETAILER_EDIT}?workflow_object=${workflow_object_id}`;
        triggerSimpleAjax(
            url,
            'GET',
            {},
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}